export enum StreamStatusValue {
  pending = 0,
  in_progress = 1,
  done = 2,
  restart = 3,
  failure = 4,
  stop = 5,
  unknown = 6,
  handler_lost = 7,
  paused = 8,
}

export interface IStreamStatusConfigItem {
  label: string;
  colorClass: string;
  textColorClass: string;
}
